import React from 'react';
export const Footer: React.FC = () => {
  return <footer className="w-full py-8 px-6 md:px-12 lg:px-20" style={{
    backgroundColor: '#f5f5f5'
  }} data-id="element-63">
      <div className="max-w-6xl mx-auto" data-id="element-64">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 items-start" data-id="element-65">
          {/* Logo */}
          <div data-id="element-66">
            <img src="https://cdn.magicpatterns.com/uploads/arTtm9z1vjHAQMMiKSujYx/wandelwert_logo_grey_800.svg" alt="wandelwert Logo" className="h-12" data-id="element-67" />
          </div>

          {/* Adresse */}
          <div className="text-sm text-gray-700 leading-relaxed" data-id="element-68">
            <p data-id="element-69">Inhaberin: Eva Sophie Schifferer</p>
            <p data-id="element-70">Rohrbachstraße 35</p>
            <p data-id="element-71">60389 Frankfurt am Main</p>
          </div>

          {/* Kontakt */}
          <div className="text-sm text-gray-700 leading-relaxed" data-id="element-72">
            <p data-id="element-73">Mobil: +49 (171) 80 80 455</p>
            <p data-id="element-74">
              E-Mail:{' '}
              <a href="mailto:schifferer@wandelwert.com" className="text-gray-700 hover:text-orange-500" data-id="element-75">
                schifferer@wandelwert.com
              </a>
            </p>
            <div className="flex items-center gap-3 mt-3" data-id="element-76">
              <a href="https://www.xing.com" target="_blank" rel="noopener noreferrer" className="text-gray-700 hover:text-orange-500 transition-colors" data-id="element-77">
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" data-id="element-78">
                  <path d="M18.188 0c-.517 0-.741.325-.927.66 0 0-7.455 13.224-7.702 13.657.015.024 4.919 9.023 4.919 9.023.17.308.436.66.967.66h3.454c.211 0 .375-.078.463-.22.089-.151.089-.346-.009-.536l-4.879-8.916c-.004-.006-.004-.016 0-.022L22.139.756c.095-.191.097-.387.006-.535C22.056.078 21.894 0 21.686 0h-3.498zM3.648 4.74c-.211 0-.385.074-.473.216-.09.149-.078.339.02.531l2.34 4.05c.004.01.004.016 0 .021L1.86 16.051c-.099.188-.093.381 0 .529.085.142.239.234.45.234h3.461c.518 0 .766-.348.945-.667l3.734-6.609-2.378-4.155c-.172-.315-.434-.659-.962-.659H3.648v.016z" data-id="element-79" />
                </svg>
              </a>
              <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer" className="text-gray-700 hover:text-orange-500 transition-colors" data-id="element-80">
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" data-id="element-81">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" data-id="element-82" />
                </svg>
              </a>
            </div>
          </div>

          {/* Links */}
          <div className="text-sm text-gray-700 leading-relaxed" data-id="element-83">
            <a href="/kontakt" className="block hover:text-orange-500" data-id="element-84">
              Kontakt
            </a>
            <a href="/impressum" className="block hover:text-orange-500 mt-1" data-id="element-85">
              Impressum
            </a>
            <a href="/datenschutz" className="block hover:text-orange-500 mt-1" data-id="element-86">
              Datenschutzerklärung
            </a>
          </div>
        </div>
      </div>
    </footer>;
};